import { render, staticRenderFns } from "./BuildMobile.vue?vue&type=template&id=086f9f4a&scoped=true&"
import script from "./BuildMobile.vue?vue&type=script&lang=js&"
export * from "./BuildMobile.vue?vue&type=script&lang=js&"
import style0 from "./BuildMobile.vue?vue&type=style&index=0&id=086f9f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f9f4a",
  null
  
)

export default component.exports